import { Avatar } from '@mui/material';
import SpeechIcon from '@mui/icons-material/RecordVoiceOver';
import FaceIcon from '@mui/icons-material/PhotoCameraFront';
import ArmsIcon from '@mui/icons-material/Accessibility';

import { green, grey, red } from '@mui/material/colors';
import { StethoscopeIcon } from '../SvgIcons/StethoscopeIcon';

export function StatusAvatar({ status, type }) {
  const color = status === 'VALID' ? green[500] : status === 'INVALID' ? red[500] : grey[500];
  const style = { bgcolor: color, width: 24, height: 24 };

  let icon;
  switch (type) {
    case 'face':
      icon = <FaceIcon sx={{ width: 16, height: 16 }} />;
      break;
    case 'speech':
      icon = <SpeechIcon sx={{ width: 16, height: 16 }} />;
      break;
    case 'arms':
      icon = <ArmsIcon sx={{ width: 16, height: 16 }} />;
      break;
    default:
      icon = <StethoscopeIcon sx={{ width: 16, height: 16 }} />;
  }

  return <Avatar sx={style}>{icon}</Avatar>;
}
